<template>
  <div :class="'vp-treeselect-' + uniqueKey">
    <svg
      v-if="showPlaceholderIcon"
      data-v-360da7f5=""
      :width="value && value.length ? 15 : 15"
      :height="value && value.length ? 15 : 15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      :class="{
        'icon-without-value': !value || !value.length,
        'icon-with-value': value && value.length,
        'vp-mt-20': value && value.length && !isMultiple,
      }"
    >
      <path
        data-v-360da7f5=""
        d="M13.7467 15C14.0674 15 14.3884 14.8777 14.6329 14.6328C15.1224 14.1435 15.1224 13.3498 14.6329 12.8603L11.586 9.8135C13.2154 7.3595 12.9497 4.00983 10.7883 1.8485C8.32362 -0.616167 4.31323 -0.616167 1.84853 1.8485C-0.616175 4.31317 -0.616175 8.3235 1.84853 10.7883C3.08088 12.0207 4.69973 12.6368 6.31842 12.6368C7.53877 12.6368 8.75879 12.2863 9.81364 11.586L12.8605 14.6328C13.105 14.8777 13.4259 15 13.7467 15ZM3.40305 9.23367C1.79569 7.62633 1.79569 5.01083 3.40305 3.4035C4.20673 2.59983 5.26257 2.19783 6.31825 2.19783C7.37394 2.19783 8.42978 2.59967 9.23363 3.4035C10.841 5.01083 10.841 7.62633 9.23363 9.23367C7.62611 10.841 5.01057 10.841 3.40305 9.23367Z"
        :fill="disabled ? '#78787860' : '#787878'"
      ></path>
    </svg>

    <span
      class="label vp-ml-52"
      :class="{
        'vp-ml-51': value && value.length && showPlaceholderIcon,
        'bg-disabled': disabled,
        'required-label': isRequired,
      }"
      v-if="label && value && value.toString().length"
    >
      {{ label }}
    </span>

    <Treeselect
      :value="value"
      @input="handleEmit"
      :class="{
        'treeselect-error': errMsg && errMsg.length > 0,
        'required-treeselect': isRequired,
        'treeselect-loading': isLoading,
      }"
      class="treeselect"
      :multiple="isMultiple"
      :clearOnSelect="clearOnSelect"
      :options="filteredOptions"
      :flat="flat"
      :autoSelectAncestors="autoSelectAncestors"
      :autoSelectDescendants="autoSelectDescendants"
      :autoDeselectAncestors="autoDeselectAncestors"
      :autoDeselectDescendants="autoDeselectDescendants"
      :sort-value-by="sortValueBy"
      :default-expand-level="+defaultExpandLevel"
      :placeholder="placeholder || label"
      :disabled="disabled"
      :noResultsText="$t('common.noOptionAvailable')"
      :disableBranchNodes="disableBranchNodes"
      :isRequired="isRequired"
      :valueFormat="valueFormat"
      :backspaceRemoves="backspaceRemoves"
      @open="onOpen(), $emit('onOpen', true)"
      @close="onClose(), $emit('onClose', true)"
      @select="selectHandler"
      @deselect="deselectHandler"
    >
      <div slot="value-label" slot-scope="{ node }">
        <span
          :class="{ isJourney: node.raw.isJourney && !node.raw.customLabel }"
          >{{
            node.raw.customLabel ? node.raw.customLabel : node.raw.label
          }}</span
        >
      </div>
    </Treeselect>
    <b-spinner
      v-if="isLoading"
      variant="secondary"
      role="status"
      size="sm"
      class="treeselect-spinner"
    />
    <div class="error-container">
      <span v-if="errMsg" class="error">{{ errMsg }}</span>
    </div>
  </div>
</template>

<script>
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { randomStringMixin } from "@/utils/mixins/generateRandomStringMixin";

import Treeselect from "@riophae/vue-treeselect";

export default {
  components: { Treeselect },
  mixins: [randomStringMixin],
  props: {
    value: {
      default: () => null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    backgroundColor: {
      type: String,
      default: "#f2f2f2",
    },
    arrowColor: {
      type: String,
      default: "#000000",
    },
    showPlaceholderIcon: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    errMsg: {
      type: String,
      default: "",
    },
    defaultExpandLevel: {
      type: String,
      default: "0",
    },
    width: {
      type: String,
      default: "416px",
    },
    noResultsText: {
      type: String,
      default: "No options available.",
    },
    disableBranchNodes: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    isMultiple: {
      type: Boolean,
      default: true,
    },
    clearOnSelect: {
      type: Boolean,
      default: true,
    },
    dropDownStyle: {
      type: String,
      default: "relative",
    },
    flat: {
      type: Boolean,
      default: true,
    },
    autoSelectAncestors: {
      type: Boolean,
      default: false,
    },
    autoSelectDescendants: {
      type: Boolean,
      default: false,
    },
    autoDeselectAncestors: {
      type: Boolean,
      default: false,
    },
    autoDeselectDescendants: {
      type: Boolean,
      default: false,
    },
    valueConsistsOf: {
      type: String,
      default: "",
    },
    sortValueBy: {
      type: String,
      default: "ORDER_SELECTED",
    },
    valueFormat: {
      //only acceps "id" , "object"
      type: String,
      default: "id",
    },
    backspaceRemoves: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      uniqueKey: this.randomString(10),
      treeselect: null,
      treeselectInputContainer: null,
      treeselectPlacholder: null,
      treeselectControl: null,
      treeselectMenu: null,
      treeselectControlArrow: null,
      treeselectMenuList: null,
      treeselectSubList: null,
      treeselectValues: null,
      treeselect_single: null,
      filteredOptions: [],
    };
  },
  methods: {
    deselectHandler(value) {
      this.$emit("deselect", value);
    },
    selectHandler(value) {
      this.$emit("select", value);
    },
    handleEmit(value) {
      this.$emit("input", value);
    },
    onOpen() {
      this.$nextTick(() => {
        this.treeselectMenuList = document.querySelector(
          `.vp-treeselect-${this.uniqueKey} .vue-treeselect__list`
        );

        this.treeselectMenu = document.querySelector(
          `.vp-treeselect-${this.uniqueKey} .vue-treeselect__menu`
        );

        this.treeselectInputContainer = document.querySelector(
          `.vp-treeselect-${this.uniqueKey} .vue-treeselect__input-container`
        );

        this.treeselectInputContainer?.style.setProperty(
          "display",
          "inline-block"
        );

        this.treeselectMenu?.style.setProperty(
          "width",
          `${this.width}px`,
          "important"
        );

        this.treeselectMenuList?.style.setProperty(
          "width",
          `${this.width}px`,
          "important"
        );
        this.setMenuPosition();
      });
    },
    onClose() {
      this.$nextTick(() => {
        this.treeselectInputContainer = document.querySelector(
          `.vp-treeselect-${this.uniqueKey} .vue-treeselect__input-container`
        );

        this.treeselectInputContainer?.style.setProperty("display", "none");

        this.setTreeselectSingle();
      });
    },
    setTreeselectInputContainer() {
      this.treeselectInputContainer = document.querySelector(
        `.vp-treeselect-${this.uniqueKey} .vue-treeselect__input-container`
      );

      if (this.isMultiple) {
        if (this.value?.length) {
          this.treeselectInputContainer?.style.setProperty(
            "margin-bottom",
            "10px"
          );
        } else {
          this.treeselectInputContainer?.style.setProperty(
            "margin-bottom",
            "unset"
          );
          this.treeselectInputContainer?.style.setProperty("margin-top", "0px");
        }
      } else if (!this.isMultiple) {
        if (this.label?.length) {
          if (this.value?.length)
            this.treeselectInputContainer?.style.setProperty(
              "margin-top",
              "25px"
            );
          else
            this.treeselectInputContainer?.style.setProperty(
              "margin-top",
              "15px"
            );
        } else {
          this.treeselectInputContainer?.style.setProperty(
            "margin-top",
            "10px"
          );
        }
      }

      if (this.isMultiple) {
        if (!this.showPlaceholderIcon)
          this.treeselectInputContainer?.style.setProperty(
            "margin-inline-start",
            "10px"
          );
        else if (this.showPlaceholderIcon && !this.value?.length)
          this.treeselectInputContainer?.style.setProperty(
            "margin-inline-start",
            "35px"
          );
        else
          this.treeselectInputContainer?.style.setProperty(
            "margin-inline-start",
            "10px"
          );
      } else {
        if (this.showPlaceholderIcon)
          this.treeselectInputContainer?.style.setProperty(
            "margin-inline-start",
            "38px"
          );
        else
          this.treeselectInputContainer?.style.setProperty(
            "margin-inline-start",
            "6px"
          );
      }
    },
    setPlaceholder() {
      this.treeselectPlacholder = document.querySelector(
        `.vp-treeselect-${this.uniqueKey} .vue-treeselect__placeholder`
      );
      if (!this.showPlaceholderIcon)
        this.treeselectPlacholder?.style.setProperty(
          "margin-inline-start",
          "4px"
        );
      else
        this.treeselectPlacholder?.style.setProperty(
          "margin-inline-start",
          "34px"
        );
    },
    setTreeselectSingle() {
      this.treeselect_single = document.querySelector(
        `.vp-treeselect-${this.uniqueKey} .vue-treeselect__single-value`
      );

      if (this.showPlaceholderIcon)
        this.treeselect_single?.style.setProperty(
          "margin-inline-start",
          "42px"
        );
      else
        this.treeselect_single?.style.setProperty(
          "margin-inline-start",
          "10px"
        );

      if (this.label)
        this.treeselect_single?.style.setProperty("margin-top", "20px");
      else this.treeselect_single?.style.setProperty("margin-top", "13px");

      if (this.disabled)
        this.treeselect_single?.style.setProperty("opacity", "0.4");
      else this.treeselect_single?.style.setProperty("opacity", "1");
    },
    setWidth() {
      this.treeselectControl = document.querySelector(
        `.vp-treeselect-${this.uniqueKey} .vue-treeselect__control`
      );

      this.treeselect?.style.setProperty("width", `${this.width}px`);

      this.treeselectControl?.style.setProperty(
        "background",
        this.backgroundColor,
        "important"
      );
      this.treeselectControl?.style.setProperty("width", `${this.width}px`);
    },
    setArrow() {
      const arrow = document.querySelector(
        `.vp-treeselect-${this.uniqueKey} .vue-treeselect svg`
      );
      arrow?.style.setProperty("fill", this.arrowColor);
    },
    disableSelected() {
      this.treeselectValues = document.querySelectorAll(
        `.vp-treeselect-${this.uniqueKey} .vue-treeselect__multi-value-item`
      );

      const removeSpanIcon = document.querySelectorAll(
        `.vp-treeselect-${this.uniqueKey} .vue-treeselect__value-remove`
      );

      const disabledNodes = document.querySelectorAll(
        `.vp-treeselect-${this.uniqueKey} .vue-treeselect__multi-value-item-disabled .vue-treeselect__value-remove ,.vue-treeselect__option--disabled`
      );

      disabledNodes?.forEach((node) => {
        node.style.setProperty("background", "transparent");
        node.style.setProperty("pointer-events", "none");
        node.style.setProperty("opacity", "0.4");
      });

      this.treeselectValues?.forEach((node) => {
        if (this.disabled) {
          node.style.setProperty("background", "#103f5e40");
          node.style.setProperty("pointer-events", "none");
        } else {
          node.style.setProperty("background", "#103f5e");
          node.style.setProperty("pointer-events", "auto");
        }
      });

      removeSpanIcon?.forEach((node) => {
        if (this.disabled) {
          node.style.setProperty("--remove-color", "#103f5e40");
        } else {
          node.style.setProperty("--remove-color", "#f46a6a");
        }
      });
    },
    setMenuPosition() {
      const menuContainer = document.querySelector(
        `.vp-treeselect-${this.uniqueKey} .vue-treeselect__menu-container`
      );
      const menu = document.querySelector(
        `.vp-treeselect-${this.uniqueKey} .vue-treeselect__menu`
      );

      menuContainer?.style.setProperty(
        "position",
        this.dropDownStyle,
        "important"
      );
      menu?.style.setProperty("position", this.dropDownStyle, "important");

      if (this.dropDownStyle == "relative")
        menu?.style.setProperty("top", "-10px");
    },
    setValueContainer() {
      const valueContainer = document.querySelector(
        `.vp-treeselect-${this.uniqueKey} .vue-treeselect__multi-value`
      );

      if (
        this.value?.length &&
        (this.showPlaceholderIcon || this.label?.length)
      ) {
        valueContainer?.style.setProperty("margin-top", "30px");
        valueContainer?.style.setProperty("margin-bottom", "15px");
        valueContainer?.style.setProperty("margin-inline-start", "6px");
      } else {
        valueContainer?.style.setProperty("margin-top", "unset");
        valueContainer?.style.setProperty("margin-bottom", "unset");
      }
    },
  },
  mounted() {
    this.treeselect = document.querySelector(
      `.vp-treeselect-${this.uniqueKey}`
    );

    this.setTreeselectInputContainer();
    this.setTreeselectSingle();
    this.setPlaceholder();
    this.setWidth();
    this.disableSelected();
    this.setValueContainer();

    this.filteredOptions = this.options.map((type) => {
      if (type.hasOwnProperty("children") && !type.children?.length) {
        delete type.children;
      }
      return type;
    });
  },
  updated() {
    this.setTreeselectInputContainer();
    this.setTreeselectSingle();
    this.setPlaceholder();
    this.setWidth();
    this.setArrow();
    this.disableSelected();
    this.setValueContainer();
  },
  watch: {
    options() {
      this.filteredOptions = this.options.map((type) => {
        if (type.hasOwnProperty("children") && !type.children?.length) {
          delete type.children;
        }
        return type;
      });
    },
    width() {
      this.setWidth();
    },
  },
};
</script>

<style lang="scss">
div[class*="vp-treeselect-"] {
  .treeselect-loading .vue-treeselect__control-arrow-container {
    display: none;
  }
  span.vue-treeselect__icon.vue-treeselect__value-remove {
    opacity: 1 !important;
  }
  .vue-treeselect__input-container input {
    margin-inline-start: 3px;
  }
  position: relative;
  display: block;
  .vue-treeselect__input {
    height: 80%;
  }
  .vue-treeselect__multi-value {
    margin-inline-start: 0px !important;
  }
  .treeselect {
    position: relative;
  }
  .label {
    position: absolute;
    color: #103f5e;
    margin-top: 10px;
    z-index: 2;
    font-size: 12px;
    font-weight: 700;
    line-height: 17px;
    letter-spacing: 0.25px;
    text-align: start;
  }

  .vue-treeselect__list-item.vue-treeselect__indent-level-1 {
    width: 800px;
  }
  .error-container {
    margin-top: 8px;
    padding-inline-start: 22px;
  }
  .vue-treeselect__control {
    width: 216px;
    padding-inline-start: 4px;
    border-radius: 4px;
    padding-inline-end: 10px;
    border: none;
    position: relative;
    height: 55px !important;
    .vue-treeselect__multi-value {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-end;
    }

    .vue-treeselect__placeholder.vue-treeselect-helper-zoom-effect-off {
      position: absolute;
      top: 20px;
      inset-inline-start: 10px;
      font-size: 16px;
      line-height: 17px;
      margin-inline-start: 36px;
      padding-inline-start: 0px !important;
      letter-spacing: 0.25px;
      color: #787878;
    }
  }

  .vue-treeselect svg {
    fill: #787878 !important;
  }
  .vue-treeselect__menu {
    width: 416px;
  }
  .vue-treeselect__multi-value-item {
    cursor: pointer;
    display: inline-table;
    background: #103f5e;
    padding: 0px !important;
    border: none;
    border-radius: 6px;
    height: 39px;
    color: #ffff;
    font-size: 12px;
    vertical-align: top;

    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    letter-spacing: 0.25px;
    overflow-wrap: anywhere;
  }
  .vue-treeselect__value-remove {
    border: none !important;
    width: 33px;
    height: 39px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
  }

  .vue-treeselect__x-container {
    display: none;
  }
  span.vue-treeselect__multi-value-label {
    padding: 11px 14px;
  }
  .vue-treeselect__value-remove > svg {
    width: 11px;
    height: 11px;
    fill: #ffffff !important;
  }
  .vue-treeselect__menu {
    max-height: 199px !important;
    border: 1px solid #ffffff;
    margin-top: 5px !important;
    border-radius: 6px;
    box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.161) !important;
  }
  .vue-treeselect__multi-value-item:hover .vue-treeselect__value-remove {
    background: var(--remove-color, #f46a6a);
    // background: #f46a6a;
  }
  .vue-treeselect__multi-value-item-container {
    margin-top: 5px;
    margin-inline-start: 15px;
    margin-bottom: 5px;
  }

  .vue-treeselect__menu::-webkit-scrollbar {
    width: 9px;
    height: 30px !important;
  }
  .vue-treeselect__menu::-webkit-scrollbar-track {
    background-color: #D1D1D1;
    padding-top: 30px !important;
    border-radius: 8.5px;
    -webkit-box-shadow: #ffff;
    margin-top: 21px !important;
    margin-bottom: 13px !important;
  }
  .vue-treeselect__menu::-webkit-scrollbar-thumb {
    background: #787878;
    border-radius: 8.5px;
  }
  .vue-treeselect__option {
    border-top: 1px solid #ebebeb;
    padding-inline-end: 10px;
    // padding-inline-start: 14px;
  }
  .vue-treeselect__label {
    font-size: 16px;
    font-weight: 400;
    font-size: 16px;
    color: #787878;
    padding-inline-start: 12px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .vue-treeselect__list-item {
    width: 98% !important;
  }

  .vue-treeselect__list:first-of-type
    > .vue-treeselect__list-item:first-of-type
    > .vue-treeselect__option:first-of-type {
    border-top: none;
  }
  .vue-treeselect__input-container {
    input {
      font-size: 16px;
    }
  }
  .vue-treeselect__checkbox {
    background-color: #ffffff !important;
    padding: 5px !important;
    border: 3px solid #787878 !important;
    border-radius: 3px !important;
    width: 17px !important;
    height: 17px !important;
  }
  .vue-treeselect__checkbox--checked {
    background-color: #787878 !important;
    border: 3px solid #787878 !important;
  }
  .vue-treeselect__check-mark,
  .vue-treeselect__minus-mark {
    background-color: #757575 !important;
    border: none !important;
    left: unset !important;
    inset-inline-start: 3px !important;
    top: 2px;
  }
  .vue-treeselect__multi-value-item-disabled,
  .vue-treeselect__option--disabled {
    opacity: 0.4;
    cursor: default;
  }
  .required-label::after,
  .required-treeselect .vue-treeselect__placeholder::after {
    content: "*";
    color: #f46a6a !important;
    margin-inline-start: 5px;
  }
  .vue-treeselect--disabled .vue-treeselect__placeholder {
    opacity: 0.4;
  }
  .icon-without-value {
    position: absolute;
    inset-inline-start: 20px;
    margin-top: 20px;
    z-index: 5;
  }
  .icon-with-value {
    position: absolute;
    inset-inline-start: 20px;
    margin-top: 10px;
    z-index: 5;
  }
  .treeselect-spinner {
    position: absolute;
    top: 24%;
    inset-inline-end: 1%;
    z-index: 1;
  }
  .spinner-border {
    width: 1.5rem;
    height: 1.5rem;
  }
  .bg-disabled {
    color: #103f5e40;
  }

  .vue-treeselect__single-value {
    margin-inline-start: 37px;
    font-size: 16px;

    color: #4a4a4a !important;
    font-weight: 700;
    height: 26px !important;
  }
  .vue-treeselect__multi-value-item-container {
    padding-top: 0;
    padding-inline-end: 0;
  }
  .treeselect-error {
    border: 2px solid #f46a6a;
    border-radius: 6px !important;
    width: fit-content;
    // margin-bottom: 8px;
  }
  .error {
    color: #f46a6a;
    font-weight: 700;
    font-size: 14px;
    letter-spacing: 0.25px;
  }
}
</style>
